export default __webpack_public_path__ + "static/media/about_us_3.60a832e9.jpeg";